export var adbRenewalMapper = function (data) {
    var result = {};
    if (data) {
        result.success = data.success;
        result.data = data.data;
    }
    return result;
};
